import { useContext, useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { FC, HoverProps } from "./typings";
import EventContext from "contexts/EventContext";
import Popper from "components/Popper";

const ContainerWithPosition = ({ children }: { children: JSX.Element }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const ref = useRef<HTMLDivElement>(null);

  const handleMouseMove = (event) => {
    const position = ref.current.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    const posY = event.clientY + position.height > windowHeight;

    setMousePosition({
      x: event.clientX,
      y: posY ? event.clientY - position.height : event.clientY,
    });
  };

  useEffect(() => {
    if (!ref?.current) return;
    const currentEvent = window.event;
    if (currentEvent) {
      handleMouseMove(currentEvent);
    } else {
      // If no event available, add listener to capture the next move
      window.addEventListener("mousemove", handleMouseMove, { once: true });
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [ref]);

  return (
    <div
      ref={ref}
      style={{
        left: mousePosition.x,
        top: mousePosition.y,
        opacity: mousePosition.x === 0 ? 0 : 1,
        position: "absolute",
      }}
      className={styles.dropdown}
    >
      {children}
    </div>
  );
};

const ContainerWithoutPosition = ({ children }: { children: JSX.Element }) => {
  return <div className={styles.dropdown}>{children}</div>;
};

const ContainerWithStaticPosition = ({
  children,
}: {
  children: JSX.Element;
}) => {
  return (
    <div
      style={{
        left: 0,
        transform: "translateX(25%)",
      }}
      className={styles.dropdown}
    >
      {children}
    </div>
  );
};

const Dropdown: FC<HoverProps> = ({
  toggle,
  options,
  rightSide,
  stati = false,
  showOptions = false,
  refWrapper,
}) => {
  const { setBlockClick } = useContext(EventContext);
  const dropRef = useRef();

  const content = () => {
    return (
      <div className={styles.dropdownWrapper} ref={dropRef}>
        {options
          .filter((option) => option.isEnabled)
          .map((option, index) => (
            <>
              {option.splitterBefore && <div className={styles.splitter}></div>}
              <div
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  option.callback();

                  toggle();
                }}
                key={index}
                className={styles.dropdownBox}
              >
                {option.Icon && <option.Icon className={styles.icon} />}
                {option.name}
              </div>
              {option.splitterAfter && <div className={styles.splitter}></div>}
            </>
          ))}
      </div>
    );
  };

  useEffect(() => {
    // setBlockClick(true);

    return () => {
      setTimeout(() => {
        setBlockClick(false);
      }, 100);
    };
  });

  if (!showOptions) return <></>;

  if (stati) {
    return (
      <ContainerWithStaticPosition>{content()}</ContainerWithStaticPosition>
    );
  }

  return (
    <Popper
      anchorEl={refWrapper?.current}
      open={showOptions}
      setOpen={() => toggle?.()}
      autoHide={false}
    >
      <div className={styles.dropdownLook}>{content()}</div>
    </Popper>
  );
};

export default Dropdown;
